// extracted by mini-css-extract-plugin
export default {"dateRange":"DateRangePicker_dateRange__XkUcj","dateContainer":"DateRangePicker_dateContainer__PCFgw","small_height":"DateRangePicker_small_height__JKf5d"};